import { createSelector } from 'reselect'
import { List } from 'immutable'

import { getLoadedLanguages } from 'store/entities/localSettings/selectors.js'

export const getOrganizationSettings = state => state.get('organizationSettings')

export const getOrganizationSettingsEntity = createSelector(getOrganizationSettings, orgSettings =>
  orgSettings.get('entity')
)

export const getOrganizationSettingsEntityLogo = createSelector(getOrganizationSettingsEntity, orgSettings =>
  orgSettings.get('logo')
)

export const getOrganizationSettingsEntityWelcomeEmailAndLanding = createSelector(
  getOrganizationSettingsEntity,
  orgSettings => orgSettings.get('welcomeEmail')
)

export const getOrganizationSettingsEntityDomain = createSelector(getOrganizationSettingsEntity, orgSettings =>
  orgSettings.get('domain')
)

export const getOrganizationSettingsEntityName = createSelector(getOrganizationSettingsEntity, orgSettings =>
  orgSettings.get('name')
)

export const getOrganizationSettingsPending = createSelector(getOrganizationSettings, orgSettings =>
  orgSettings.get('pending')
)

export const getOrganizationSettingsPendingGet = createSelector(getOrganizationSettingsPending, pending =>
  pending.get('get')
)

export const getOrganizationSettingsPendingByDomain = createSelector(getOrganizationSettingsPending, pending =>
  pending.get('settingsByDomain')
)

export const getPendingPromoPageSettings = createSelector(getOrganizationSettingsPending, pending =>
  pending.get('promoPage')
)

export const getOrganizationSettingsByDomain = createSelector(getOrganizationSettings, orgSettings =>
  orgSettings.get('settingsByDomain')
)

const getOrganizationSettingsLanguageByDomain = createSelector(getOrganizationSettingsByDomain, orgSettings =>
  orgSettings.get('language')
)

export const getOrganizationSettingsByDomainCountriesCodes = createSelector(
  getOrganizationSettingsByDomain,
  orgSettings => orgSettings.get('countriesCodes')
)

const translationsBundleForCurrentLanguage = createSelector(
  getOrganizationSettingsLanguageByDomain,
  getLoadedLanguages,
  (language, languages) => {
    const translationsBundles = languages && languages.get(language)
    return translationsBundles || (languages && languages.get('en')) || List()
  }
)

export const isTranslationsLoadedForLoginPage = createSelector(translationsBundleForCurrentLanguage, languageBundle => {
  return languageBundle.includes('login')
})

export const isTranslationsLoadedForDashboardPage = createSelector(
  translationsBundleForCurrentLanguage,
  languageBundle => languageBundle.includes('user')
)

export const isTranslationsCommonLoaded = createSelector(translationsBundleForCurrentLanguage, languageBundle =>
  languageBundle.includes('common')
)

export const isTranslationsLoadedForAdminsPages = createSelector(translationsBundleForCurrentLanguage, languageBundle =>
  languageBundle.includes('admin')
)

export const getPromoPageSettings = createSelector(getOrganizationSettings, orgSettings => orgSettings.get('promoPage'))

export const getOrganizationSettingsLoaded = createSelector(getOrganizationSettings, orgSettings =>
  orgSettings.get('loaded')
)

export const getOrganizationSettingsChildrenList = createSelector(getOrganizationSettings, orgSettings =>
  orgSettings.get('children')
)
